<template>
  <b-card>
    <validation-observer ref="otherConfigurationRules">
      <b-form>
        <b-row class="mt-2">
          <b-col md="6">
            <SelectField
              id="default-overdraft-interest "
              v-model="otherConfigurationFormData.config.defaultOverdraftInterest"
              :label="$t('Default Overdraft Interest')"
              :placeholder="$t('Select')"
              :reduce="option => option.value"
              :options="defaultOverdraftInterestOptions"
              :error-name="$t('Default Overdraft Interest')"
              rules="required"
              item="label"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>

        <div class="mt-2">
          <b-row>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-5"
                v-model="otherConfigurationFormData.config.accrueFee"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Accrue Fee') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-1"
                v-model="otherConfigurationFormData.config.skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Skip loan repayment that falls on weekends and public holidays') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-2"
                v-model="otherConfigurationFormData.config.allowDepositOnDormantAccounts"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Allow Deposits on Dormant Accounts') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-3"
                v-model="otherConfigurationFormData.config.allowMultipleLoansPerAccount"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Allow Force Debit on Account') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-4"
                v-model="otherConfigurationFormData.config.usePhoneNumberAsAccountNumber"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Use Phone Number as Account Number') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="12"
              class="mt-2"
            >
              <b-form-checkbox
                id="switch-6"
                v-model="otherConfigurationFormData.config.enableAuditTrailForCustomerBalance"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Enable Audit Trail For Customer Balance') }} </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="6"
              class="mt-2"
            >
              <b-form-checkbox
                id="debit-customers-sms-everyEndOfMonth"
                v-model="otherConfigurationFormData.config.debitCustomersForSMSEveryEndOfMonth"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
                @change="toggleDebitCustomersForSMSEvery(otherConfigurationFormData.config.debitCustomersForSMSEveryEndOfMonth)"
              >
                <span> {{ $t('Debit Customers for SMS Every End Of Month') }} </span>
              </b-form-checkbox>
            </b-col>
            <b-col md="6">
              <SelectField
                id="debit-customers-sms-Every"
                v-model="otherConfigurationFormData.config.debitCustomersForSMSEvery"
                :label="$t('Debit Customers for SMS Every')"
                :options="debitCustomersForSMSEveryOptions"
                :reduce="option => option.value"
                :placeholder="$t('Select')"
                item="label"
                :readonly="isDisabledText"
              />
            </b-col>
            <b-col
              md="6"
              class="mt-2"
            >
              <b-form-checkbox
                id="enforce-kyc-at-customer-creation"
                v-model="otherConfigurationFormData.config.enforceKYCAtCustomerCreation"
                name="check-button"
                switch
                inline
                :disabled="isReadonly"
              >
                <span> {{ $t('Enforce KYC At Customer Creation') }} </span>
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>

        <div class="mt-5">
          <h6 class="section-label mb-2 mt-2 ">
            {{ $t('Cheque Information') }}
          </h6>

          <b-row>
            <b-col md="6">
              <InputNumberField
                id="default-cheque"
                v-model="otherConfigurationFormData.config.defaultChequeClearingDurationInDays"
                :label="$t('Default Cheque Clearing Duration (In Days)')"
                :error-name="$t('Default Cheque Clearing Duration')"
                rules="required|integer|positive"
                :readonly="isReadonly"
              />
            </b-col>

            <b-col md="6">
              <SwitchButton
                v-model="otherConfigurationFormData.config.applyCommissionOnChequeDeposit"
                :label="$t('Apply Commission on Cheque deposit')"
                name="apply-commission"
                class="mt-2"
                :readonly="isReadonly"
              />
            </b-col>
          </b-row>

          <b-row v-if="setApplyCommission(otherConfigurationFormData.config.applyCommissionOnChequeDeposit)">
            <b-col md="6">
              <InputField
                id="percentage"
                v-model.number="otherConfigurationFormData.config.commissionOnCheques"
                :label="$t('Commission on Cheques %')"
                :placeholder="$t('Enter percentage')"
                type="number"
                :error-name="$t('Commission on Cheques')"
                rules="required|max-value:100|positive"
                :readonly="isReadonly"
              />
            </b-col>

            <b-col md="6">
              <SelectField
                id="commission-cheque"
                v-model="otherConfigurationFormData.config.commissionOnChequeIncomeAccount"
                :label="$t('Commission on Cheques Income Account')"
                :options="commissionChequesOptions"
                :placeholder="$t('Select')"
                :reduce="option => option.value"
                item="label"
                rules="required"
                :error-name="$t('Commission on Cheques Income Account')"
                :readonly="isReadonly"
                :loading="isLoadingCommission"
              />
            </b-col>
          </b-row>
        </div>

        <div class="text-center">
          <Button
            v-if="getUserPermission('MODIFY_SYSTEM_SETUP')"
            :label="buttonLabel"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="saveOtherConfiguration(buttonLabel)"
          />
        </div>
      </b-form>
    </validation-observer>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required, positive } from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import SelectField from '../../../../forms/SelectField.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import InputField from '../../../../forms/InputField.vue'
import Button from '../../../../components/button/Button.vue'
import { operationPermissions } from '../../../../../helpers/permissions'
import SwitchButton from '../../../../components/switch/Switch.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormCheckbox,
    SelectField,
    SwitchButton,
    InputNumberField,
    InputField,
    ValidationObserver,
    FullScreenSpinner,
    Button,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      isReadonly: true,
      isLoadingCommission: false,
      isEditable: true,
      isDisabled: false,
      isDisabledText: true,
      isLoading: false,
      showSpinner: false,
      buttonLabel: this.$t('Edit'),
      required,
      positive,
      commissionChequesOptions: [],
      otherConfigurationFormData: {
        config: {
          accrueFee: false,
          allowMultipleLoansPerAccount: false,
          usePhoneNumberAsAccountNumber: false,
          enableAuditTrailForCustomerBalance: false,
          skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays: false,
          allowDepositOnDormantAccounts: false,
          defaultOverdraftInterest: '',

          defaultChequeClearingDurationInDays: 0,
          applyCommissionOnChequeDeposit: true,
          commissionOnCheques: 0,
          commissionOnChequeIncomeAccount: '',
          debitCustomersForSMSEveryEndOfMonth: true,
          debitCustomersForSMSEvery: '',
          enforceKYCAtCustomerCreation: false,
        },
      },
      defaultOverdraftInterestOptions: [],
      debitCustomersForSMSEveryOptions: [
        { label: '27th', value: 27 },
        { label: '28th', value: 28 },
        { label: '1st', value: 1 },
        { label: '2nd', value: 2 },
      ],
    }
  },
  mounted() {
    this.fetchInterest()
    this.fetchOtherConfiguration()
    this.fetchAccountCategory()
  },
  methods: {
    ...mapActions({
      getOtherConfiguration: 'operations/getOtherConfigurationList',
      updateOtherConfiguration: 'operations/updateOtherConfigurationAction',
      getInterest: 'account/getInterestList',
      getAccountGLsCategory: 'account/getAccountGLsCategoryList',
    }),
    async fetchAccountCategory() {
      try {
        this.isLoadingCommission = false
        const response1 = await this.getAccountGLsCategory({
          search: { accountCategoryCode: 40101000 },
          page: 1,
          limit: 200,
          permission: operationPermissions.VIEW_SYSTEM_SETUP,
        })
        const response2 = await this.getAccountGLsCategory({
          search: { accountCategoryCode: 40102000 },
          page: 1,
          limit: 200,
          permission: operationPermissions.VIEW_SYSTEM_SETUP,
        })

        if (response1.status === 200 && response2.status) {
          const commission1 = response1.data.data
          const commission2 = response2.data.data
          if (commission1 && commission2) {
            this.commissionChequesOptions = [...commission1, ...commission2].map(item => ({
              label: item.name,
              value: item.code.toString(),
            }))
          }
        } else {
          this.commissionChequesOptions = []
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingCommission = false
      }
    },
    setApplyCommission(value) {
      if (!value) {
        this.otherConfigurationFormData.config.commissionOnCheques = 0
        this.otherConfigurationFormData.config.commissionOnChequeIncomeAccount = ''
        return false
      }
      return true
    },
    toggleDebitCustomersForSMSEvery(dataValue) {
      if (dataValue === false) {
        this.otherConfigurationFormData.config.debitCustomersForSMSEvery = null
        this.isDisabledText = false
      } else {
        this.isDisabledText = true
        this.otherConfigurationFormData.config.debitCustomersForSMSEvery = null
      }
    },
    saveOtherConfiguration() {
      if (this.buttonLabel === this.$t('Save Changes')) {
        this.$refs.otherConfigurationRules.validate().then(success => {
          if (success) {
            this.confirm(this.handleSubmit, { text: this.$t('Are you sure you want to Update this Other Configurations?') })
          }
        })
      } else {
        this.isReadonly = false
        this.isEditable = true
        this.isDisabledText = true
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        const response = await this.updateOtherConfiguration({
          config: {
            ...this.otherConfigurationFormData.config,
            accrueFee: this.otherConfigurationFormData.config.accrueFee,
            allowMultipleLoansPerAccount: this.otherConfigurationFormData.config.allowMultipleLoansPerAccount,
            usePhoneNumberAsAccountNumber: this.otherConfigurationFormData.config.usePhoneNumberAsAccountNumber,
            enableAuditTrailForCustomerBalance: this.otherConfigurationFormData.config.enableAuditTrailForCustomerBalance,
            skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays: this.otherConfigurationFormData.config.skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays,
            allowDepositOnDormantAccounts: this.otherConfigurationFormData.config.allowDepositOnDormantAccounts,
            defaultOverdraftInterest: this.getDefaultOverdraftInterest(this.otherConfigurationFormData.config.defaultOverdraftInterest),
            debitCustomersForSMSEveryEndOfMonth: this.otherConfigurationFormData.config.debitCustomersForSMSEveryEndOfMonth,
            debitCustomersForSMSEvery: this.otherConfigurationFormData.config.debitCustomersForSMSEvery,
            enforceKYCAtCustomerCreation: this.otherConfigurationFormData.config.enforceKYCAtCustomerCreation,
          },
        })

        const { status } = await response
        if (status === 200) {
          this.fetchOtherConfiguration()
          this.alertSuccess({ text: this.$t('Your request to Update Other Configurations was successful') })
          this.isReadonly = true
          this.isEditable = true
          this.isDisabledText = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = 'Edit'
        }
      } catch (error) {
        const requestToText = this.$t('Your request to Update Other Configurations failed. \nReason:')
        this.alertError({ text: `${requestToText} ${this.readError(error)}` })
      } finally {
        this.isEditable = true
        this.isDisabledText = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    toggleButtonLabel() {
      this.isReadonly = false
      this.isEditable = true
      this.isDisabledText = false
      this.buttonLabel = this.$t('Save Changes')
    },
    getDefaultOverdraftInterest(data) {
      if (data !== null || undefined) {
        if (typeof data === 'object') {
          return this.defaultOverdraftInterestOptions.find(item => item.value === data.value).value
        }
        if (typeof data === 'string') {
          return this.defaultOverdraftInterestOptions.find(item => item.value === data).value
        }
      }
      return ''
    },
    async fetchOtherConfiguration() {
      try {
        this.showSpinner = true
        await this.fetchInterest()
        const response = await this.getOtherConfiguration({ permission: operationPermissions.VIEW_SYSTEM_SETUP })
        const { status, data } = response
        if (status === 200 && data.data) {
          const defaultOverdraftInterest = this.defaultOverdraftInterestOptions.find(item => item.value === data.data.defaultOverdraftInterest)
          this.otherConfigurationFormData.config = {
            defaultOverdraftInterest,
            accrueFee: data.data.accrueFee,
            allowMultipleLoansPerAccount: data.data.allowMultipleLoansPerAccount,
            usePhoneNumberAsAccountNumber: data.data.usePhoneNumberAsAccountNumber,
            enableAuditTrailForCustomerBalance: data.data.enableAuditTrailForCustomerBalance,
            skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays: data.data.skipLoanRepaymentFallingOnWeekdaysAndPublicHolidays,
            allowDepositOnDormantAccounts: data.data.allowDepositOnDormantAccounts,

            defaultChequeClearingDurationInDays: data.data.defaultChequeClearingDurationInDays,
            applyCommissionOnChequeDeposit: data.data.applyCommissionOnChequeDeposit,
            commissionOnCheques: data.data.commissionOnCheques,
            commissionOnChequeIncomeAccount: data.data.commissionOnChequeIncomeAccount,
            debitCustomersForSMSEveryEndOfMonth: data.data.debitCustomersForSMSEveryEndOfMonth,
            debitCustomersForSMSEvery: data.data.debitCustomersForSMSEvery,
            enforceKYCAtCustomerCreation: data.data.enforceKYCAtCustomerCreation,
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async fetchInterest() {
      try {
        const response = await this.getInterest({
          search: '',
          page: 0,
          limit: 0,
          permission: operationPermissions.VIEW_SYSTEM_SETUP,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.defaultOverdraftInterestOptions = data.data.filter(item => item.type === 'Debit').map(item => ({ label: item.name, value: item.id }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
  },
}
</script>
<style scoped>
.custom-checkbox:last-child{
    margin-left: 20px !important;
}
</style>
